import React from "react";
import RadioButton from "../../../components/Atomos/Radio/RadioButton";

export interface RadioOption<T extends string> {
  value: T;
  label: string;
}

interface RadioGroupProps<T extends string> {
  title: string;
  options: RadioOption<T>[];
  value: T;
  onChange: (value: T) => void;
  name: string;
  disabled?: boolean;
  showTitle?: boolean;
  color?: "primary" | "secondary" | "accent";
}

export default function RadioGroup<T extends string>({
  title,
  options,
  value,
  onChange,
  name,
  disabled = false,
  showTitle = true,
  color,
}: RadioGroupProps<T>) {
  const radioSize = "w-5 h-5 p-[.15rem]";
  const fontSize = "text-sm font-medium text-gray-font";

  const handleChange = (index: number) => {
    onChange(options[index].value);
  };

  return (
    <div className="flex flex-col justify-between">
      {showTitle && (
        <span className="text-lg font-semibold leading-none text-gray-font mb-3">
          {title}
        </span>
      )}
      <div className="flex items-center gap-6 h-[48px]">
        {options.map((option, index) => (
          <RadioButton
            key={option.value}
            index={index}
            text={option.label}
            selected={value === option.value}
            handleRadioButtonChange={handleChange}
            name={name}
            radioSize={radioSize}
            fontSize={fontSize}
            disabled={disabled}
            color={color}
          />
        ))}
      </div>
      <div className="h-0" />
    </div>
  );
}
